import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SunDetailsStore {

	showSunDetails: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public setShowSunDetails(state: boolean) {
		this.showSunDetails.next(state);
	}

}
